import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import VehicleListTable from './Components/VehicleListTable'

const VehicleDetailsList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Vehicle List</HeadingOne>
                    <AddItemBtn url="add-vehicle" title="Create" />
                </>
            }>

            <div className="col-12">
                <VehicleListTable />
            </div>
        </PageBody>
    )
}

export default VehicleDetailsList
